import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = Parameters<typeof apiClient.previewPlanCreation>[0];

export const usePreviewPlanCreation = (params: Params, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [{ entity: "preview_plan_creation", params }],
    queryFn: async () => await apiClient.previewPlanCreation(params),
    retry: false,
    ...options,
  });
};
